/* @flow */

import { get } from 'lodash';

import { constants } from '../actions/modal';
import type { StateType, ActionType } from '../actions/modal';

export const initialState: StateType = {
  modalType: null,
  modalProps: {},
};

export default function (state: StateType = initialState, action: ActionType): StateType {
  switch (action.type) {
    case constants.SHOW_MODAL:
      return {
        modalType: get(action.data, 'modalType'),
        modalProps: get(action.data, 'modalProps'),
      };
    case constants.HIDE_MODAL:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modal.js